<template>
    <div>
      <common-dialog
        ref="dialog"
        width="1200px"
        unit="门店信息"
        edit-title
        :show-save-button="$permission.canEdit()"
        id-key="RecordId"
        :data="data"
        :get-data-func="api.info"
        :form-rules="rules"
        :save-func="api.save"
        @create-opened="onCreateOpened"
        @edit-opened="onEditOpened"
        :before-save="onBeforeSave"
        close-on-saved
        form-label-width="105px"
        @close-saved="$emit('close-saved')"
        @closed="onClosed"
        in-dialog
      >
        <template slot="form">
         
            <el-row>
              <el-col :span="isMB?24:12">
                <el-form-item label="门店名称" prop="StoreName">
                  <el-input v-model="data.StoreName" placeholder="请输入门店名称" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="isMB?24:12">
                <el-form-item label="门店编号" prop="StoreCode">
                    <el-input v-model="data.StoreCode" placeholder="请输入门店编号" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="isMB?24:12">
                <el-form-item label="所属商家" prop="BusiId">
                  <el-select v-model="data.BusiId"  placeholder="请选择所属商家">
                    <el-option v-for="item in busiList" :key="item.RecordId" :value="item.RecordId" :label="item.BusiName" ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
             
              <el-col :span="isMB?24:12">
                <el-col :span="13">
                  <el-form-item label="营业时间" prop="TradeTimebegin">
                    <el-time-picker
                      v-model="data.TradeTimebegin"
                      format="HH:mm"
                      value-format="HH:mm:ss"
                      placeholder="选择开始时间"
                    >
                    </el-time-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="1">
                  <div style="margin-top: 5px;text-align: center;">-</div>
                </el-col>
                <el-col :span="10">
                  <el-form-item prop="TradeTimeend" label-width="0">
                    <el-time-picker
                      v-model="data.TradeTimeend"
                      format="HH:mm"
                      value-format="HH:mm:ss"
                      placeholder="选择结束时间"
                    >
                    </el-time-picker>
                  </el-form-item>
                </el-col>
              </el-col>
              <el-col :span="isMB?24:12">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="所在区域" prop="StorePro">
                      <el-select v-model="data.StorePro" placeholder="请选择" @change="proChange">
                        <el-option v-for="item in list2" :key="item.DistrictId" :value="item.Name"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item prop="StoreCity" label-width="0">
                      <el-select v-model="data.StoreCity" placeholder="请选择" @change="data.StoreArea = ''" :disabled="!data.StorePro">
                        <el-option v-for="item in list3" :key="item.DistrictId" :value="item.Name"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item prop="StoreArea" label-width="0">
                      <el-select v-model="data.StoreArea" placeholder="请选择" :disabled="!data.StoreCity">
                        <el-option v-for="item in list4" :key="item.DistrictId" :value="item.Name"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
           
            <el-row>
              <el-col :span="24">
                <el-form-item label="实体店地址" prop="StoreAddress">
                  <el-input v-model="data.StoreAddress" placeholder="请输入实体店地址" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
               
            
            <el-row>
                 
              <el-col :span="isMB?24:12">
                <el-form-item label="地图位置" prop="MapPosition">
                  <el-input v-model="data.MapPosition" placeholder="请输入纬度，经度（使用英文逗号隔开）或点击图标选点">
                    <el-button slot="append" icon="el-icon-location-outline" @click.native="onMap(data)" title="从地图选择"></el-button>
                  </el-input>
                </el-form-item>
              </el-col>

              <el-col :span="isMB?24:12">
                <el-form-item label="执照编号" prop="LicenseCode">
                  <el-input v-model="data.LicenseCode" placeholder="请输入执照编号" clearable></el-input>
                </el-form-item>
              </el-col>

            </el-row>
            <!---->
            <el-row>
              <el-col :span="isMB?24:12">
                <el-form-item label="联系人员" prop="ContactName">
                  <el-input v-model="data.ContactName" placeholder="请输入联系人员" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="isMB?24:12">
                <el-form-item label="联系电话" prop="ContactPhone">
                    <el-input v-model="data.ContactPhone" placeholder="请输入联系电话" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            

            <el-row>
                           
              <el-col :span="isMB?24:12">
                <el-form-item label="门店类型" prop="StoreType">
                  <el-radio-group v-model="data.StoreType">
                    <el-radio :label="0">自营</el-radio>
                    <el-radio :label="1">加盟</el-radio>
                   
                  </el-radio-group>
                </el-form-item>
              </el-col>

              <el-col :span="isMB?24:12">
                <el-form-item label="客服链接" prop="ServiceLink">
                  <el-input v-model="data.ServiceLink" placeholder="请输入客服链接" clearable></el-input>
                </el-form-item>
              </el-col>

            </el-row>

            <el-row>
              <el-col :span="isMB?24:12">
                <el-form-item label="银行名称" prop="BankName">
                  <el-input v-model="data.BankName" placeholder="请输入银行名称" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="isMB?24:12">
                <el-form-item label="银行卡号" prop="BankCardid">
                    <el-input v-model="data.BankCardid" placeholder="请输入银行卡号" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            
            <el-row>
              <el-col :span="isMB?24:12">
                <el-form-item label="持卡人证件" prop="BankPersoncode">
                  <el-input v-model="data.BankPersoncode" placeholder="请输入持卡人证件" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="isMB?24:12">
                <el-form-item label="预留手机号" prop="BankReservephone">
                    <el-input v-model="data.BankReservephone" placeholder="预留手机号" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="isMB?24:12">
                <el-form-item label="序号" prop="OrderId">
                  <el-input-number v-model="data.OrderId" :min="0" />
                </el-form-item>
              </el-col>
              <el-col :span="isMB?24:12">
                <el-form-item label="状态" prop="State">
                  <el-radio-group v-model="data.State">
                    <el-radio :label="1">启用</el-radio>
                    <el-radio :label="0">停用</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
                           
              <el-col :span="isMB ? 24 : 12" v-if="data.RecordId">
               <el-form-item label="数据来源">
                  {{ data.DataSource == 0 ? "平台添加" : "OAO推送" }}
                </el-form-item>
              </el-col>
            </el-row>
               
         
        </template>
        <template #footer v-if="!$permission.canEdit()">
             <el-button @click="close">关 闭</el-button>
        </template>
      </common-dialog>
      <map-dialog ref="mapDialog" @select="selectmap" selectable></map-dialog>
      <el-dialog :visible.sync="dialogVisible" title="查看图片" append-to-body>
        <img width="100%" :src="dialogImageUrl" alt="" />
      </el-dialog>
    </div>
  </template>
  <script>
  import editDialogMixin from "@/mixins/editDialog";
  import commonDialog from "@/components/common/dialog";
  import singlePicUpload from "@/components/common/photo/singleUpload";
  import mapDialog from '@/components/common/maps/qq/mapDialog';
  
  export default {
    mixins: [editDialogMixin],
    components: {
      commonDialog,
      singlePicUpload,
      mapDialog
    },
    props: {
      
    },
    computed: {
      host() {
        return window.location.origin;
      },
      list2() {
        return this.area.filter((x) => x.Lv == 1);
      },
      list3() {
        if (this.id1)
          return this.area.filter((x) => x.Lv == 2 && x.Pid == this.id1);
        else return [];
      },
      list4() {
        if (this.id2)
          return this.area.filter((x) => x.Lv == 3 && x.Pid == this.id2);
        else return [];
      },
      id1() {
        if (!this.data.StorePro) return 0;
        else {
          var obj = this.area.find((x) => x.Name == this.data.StorePro);
          return obj ? obj.DistrictId : 0;
        }
      },
      id2() {
        if (!this.data.StoreCity) return 0;
        else {
          var obj = this.area.find((x) => x.Name == this.data.StoreCity);
          return obj ? obj.DistrictId : 0;
        }
      },
      id3() {
        if (!this.data.StoreArea) return 0;
        else {
          var obj = this.area.find((x) => x.Name == this.data.StoreArea);
          return obj ? obj.DistrictId : 0;
        }
      },
    },
    data() {
      return {
        data: {
          RecordId: 0,
          OrderId: 0,
          StoreName: "",
          StoreCode: "",
          BusiId: null,
          TradeTimebegin: "",
          TradeTimeend: "",
        
          StoreAddress: "",
                  
          StorePro: "",
          StoreCity: "",
          StoreArea: "",
          StoreType: 0,
          DataSource: 0,

          State: 1,
          DistrictId: 0,
          MapPosition:"",
          ContactName:"",
          ContactPhone:"",
          LicenseCode:"",
          LicensePhoto:"",
          ServiceLink:"",
          BankName:"",
          BankCardid:"",
          BankPersoncode:"",
          BankReservephone:"",
          MapLongitude:"",
          MapLatitude:""
        },
      
        busiList: [],
      
        formData: [],
        formData2: [],
        nowObj: {},
        tags: [],
       
        dialogImageUrl: '',
        dialogVisible: false,
        api: require("@/api/shop/store").default,
        api2: require("@/api/sale/district").default,
        api3: require("@/api/shop/business").default, //商家名称接口
      
        headers: { Authorization: 'Bearer ' + this.$commonJs.getCookie("token") },//传图片时加上token
        dialogImageUrl: '',
        isMB: this.$store.state.isMB,
        showEditor: false,
        rules: {
          StoreName: [{ required: true, message: "门店名称不能为空" }],
          BusiId: [{ required: true, message: "商家名称不能为空" }],
         
          TradeTimebegin: [{ required: true, message: "请选择开始营业时间" }],
          TradeTimeend: [{ required: true, message: "请选择结束营业时间" }],
          // ShopDomino: [{ required: true, message: "店铺域名不能为空" }],
          StoreAddress: [{ required: true, message: "实体地址不能为空" }],
          // TradeDescribe: [{ required: true, message: "主营描述不能为空" }],
          StorePro: [{ required: true, message: "请选择省份" }],
          StoreCity: [{ required: true, message: "请选择城市" }],
          StoreArea: [{ required: true, message: "请选择行政区" }],
         // EntityPhoto: [{ required: true, message: "实体照片不能为空" }],
         ContactPhone: [{ validator: this.$commonJs.validateRules.validPhone2 }],
         BankReservephone: [{ validator: this.$commonJs.validateRules.validPhone2 }],
          OrderId: [{ required: true, message: "序号不能为空" }],
        },
        uploadUrl: "/api/Common/UploadPicture",
        area:[]
      };
    },
    methods: {
      onCreateOpened(data) {
        this.getOption();
        this.api.getMaxOrderId().then((res) => {
          if (res.Code == 0) this.data.OrderId = res.Data;
        });
               
      },
      onEditOpened(data) {
        this.showEditor = true;
        this.getOption();
       
        
       
        if(data.TradeTimebegin.length==5) {
          this.data.TradeTimebegin += ":00";
          this.data.TradeTimeend += ":00";
        }
      },
      getOption() {
       // this.loading(true);
        
        this.api3.list({}).then((res) => {
          if (res.Code == 0) {
            this.busiList = res.Data;
          }
        });     
        
          this.api2.list({}).then((res) => {
          if (res.Code == 0) {
            this.area = res.Data;
          }
        });     
        
       
      },
                     
      
      proChange() {
        this.data.ShopCity = "";
        this.data.ShopArea = "";
      },
      onBeforeSave() {
       
        this.data.DistrictId = this.id3;
         
        
        
      },
      onMap(item) {
        this.nowObj = item;
        this.$refs.mapDialog.open({}).then(that => {
          if(item.MapPosition) {
            var arr = item.MapPosition.split(",");
            if(arr.length==2 && arr[0] && arr[1]) {
              that.setLocation({ lat: arr[0], lng: arr[1] });
              return;
            }
          }
          that.setLocation({ lat: 23.354349, lng: 116.681938 });
        });
      },
      selectmap(e) {
        this.data.MapLatitude = e.location.lat.toFixed(6);
        this.data.MapLongitude = e.location.lng.toFixed(6);
        this.nowObj.MapPosition = e.location.lat.toFixed(6) + "," + e.location.lng.toFixed(6);
      },
         
      onClosed() {
        
        this.busiList = [];
       
        this.formData = [];
        this.formData2 = [];
        this.tags = [];
       
      },
      
    },
  };
  </script>
  <style lang="scss" scoped>
  .upload-tip {
    transform: translateY(26px);
    margin-left: 10px;
  }
  </style>
  